import { defineMessages } from 'react-intl';

export default defineMessages({
  viewRewardsLink: {
    id: 'shared.loyaltyStatus.viewRewardsLink',
    defaultMessage: 'View your Rewards status.',
    description: 'Button text to view your Rewards status',
  },
});
